"use client";

import { useEffect, useState } from "react";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "./carousel";

const images = [
  { src: '/slideshow1.jpg', alt: 'Elev lucrând la un exercițiu de limba română' },
  { src: '/slideshow2.jpg', alt: 'Lecție de limba spaniolă la tablă' },
  { src: '/slideshow3.jpg', alt: 'Elev completând un exercițiu într-un caiet' },
  { src: '/slideshow4.jpg', alt: 'Profesor explicând o lecție de limba română' },
  { src: '/slideshow5.jpg', alt: 'Lecție interactivă la tablă' },
  { src: '/slideshow6.jpg', alt: 'Profesor și elev discutând un exercițiu de engleză' },
  { src: '/slideshow7.jpg', alt: 'Elevă lucrând individual la masă' },
  { src: '/slideshow8.jpg', alt: 'Profesor explicând un text în limba engleză' },
  { src: '/slideshow9.jpg', alt: 'Elevi participând la o lecție de limbi străine' }
];

function ImageCarousel() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    const handleSelect = () => {
      setCurrent(api.selectedScrollSnap());
    };
    api.on("select", handleSelect);

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = prefersReducedMotion ? undefined : window.setInterval(() => {
      api.scrollNext();
    }, 5000);

    // Cleanup interval când componenta este demontată
    return () => {
      if (interval) window.clearInterval(interval);
      api.off("select", handleSelect);
    };
  }, [api]);

  const opts = {
    align: "start",
    loop: true, // Permite scroll infinit
  };

  return (
    <div className="w-full">
      <Carousel 
        setApi={setApi} 
        className="w-full relative"
        opts={opts}
      >
        <CarouselContent>
          {images.map((image) => (
            <CarouselItem key={image.src} className="basis-full md:basis-1/2 lg:basis-1/3">
              <div className="relative aspect-[4/3] overflow-hidden rounded-[1.5rem]">
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  className="object-cover w-full h-full"
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden !left-2 !h-11 !w-11 bg-paper md:flex" />
        <CarouselNext className="hidden !right-2 !h-11 !w-11 bg-paper md:flex" />
      </Carousel>

      {/* Indicatori pentru slide-uri */}
      <div className="mt-4 flex justify-center">
        {images.map((_, index) => (
          <button
            key={index}
            type="button"
            aria-label={`Afișează imaginea ${index + 1}`}
            className="flex h-11 w-8 items-center justify-center"
            onClick={() => api?.scrollTo(index)}
          >
            <span className={`h-3 w-3 rounded-full transition-colors ${
              index === current ? 'bg-blue-600' : 'bg-gray-300'
            }`} />
          </button>
        ))}
      </div>
    </div>
  );
}

export { ImageCarousel };
